import TableTransactionsCurrency from './components/TableTransactionsCurrency'

export default TableTransactionsCurrency